module.exports = __webpack_public_path__ + "static/media/icon-horizontal-bat.d4d6dbd9.svg";